/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FileDtoFromJSON, FileDtoToJSON, } from './';
export function SignaturesDtoFromJSON(json) {
    return SignaturesDtoFromJSONTyped(json, false);
}
export function SignaturesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerFullName': !exists(json, 'customerFullName') ? undefined : json['customerFullName'],
        'byCustomer': !exists(json, 'byCustomer') ? undefined : FileDtoFromJSON(json['byCustomer']),
        'byEmployee': !exists(json, 'byEmployee') ? undefined : FileDtoFromJSON(json['byEmployee']),
    };
}
export function SignaturesDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerFullName': value.customerFullName,
        'byCustomer': FileDtoToJSON(value.byCustomer),
        'byEmployee': FileDtoToJSON(value.byEmployee),
    };
}
